import { useCallback } from 'react';
import { useClient } from 'urql';
import {
  ScanToPayMachineContext,
  SetDefaultPaymentMethodParams,
} from '../../machine/scan-to-pay.machine.types';
import {
  ScanToPaySetDefaultPaymentMethodDocument,
  ScanToPaySetDefaultPaymentMethodMutation,
  ScanToPaySetDefaultPaymentMethodMutationVariables,
} from '../../graphql/ScanToPayDefaultPaymentMethod.generated';

// ────────────────────────────────────────────────────────────────────────────

/**
 * A hook for setting the default payment method.
 */
export const useScanToPayDefaultPaymentMethod = () => {
  const client = useClient();

  // ─── Mutations ────────────────────────────────────────────────────────────

  const setDefaultPaymentMethod = useCallback(
    async (
      _context: ScanToPayMachineContext,
      { params }: SetDefaultPaymentMethodParams,
    ) => {
      const mutation = client.mutation<
        ScanToPaySetDefaultPaymentMethodMutation,
        ScanToPaySetDefaultPaymentMethodMutationVariables
      >;

      const response = await mutation(
        ScanToPaySetDefaultPaymentMethodDocument,
        params,
        { requestPolicy: 'network-only' },
      ).toPromise();

      const paymentMethodId =
        response.data?.setDefaultPaymentMethod.defaultCardId ?? '';

      return { paymentMethodId };
    },
    [client.mutation],
  );

  // ──────────────────────────────────────────────────────────────────────────

  return { setDefaultPaymentMethod };
};
